import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { GetInvoicesbySalesOrderIdResponseDto } from "../models/orders/getInvoicebySalesOrderIdResponseDto.dto";
import { GetProjectInvoiceReportRequestDto } from "../models/orders/getProjectInvoiceReportRequestDto";
import { GetProjectInvoiceReportResponseDto } from "../models/orders/getProjectInvoiceReportResponseDto";
import { GetProjectInvoiceReportSalesRequestDto } from "../models/orders/getProjectInvoiceReportSalesRequestDto";
import { GetProjectInvoiceReportSalesResponseDto } from "../models/orders/getProjectInvoiceReportSalesResponseDto";
import { GetSaleOrdersDto } from "../models/orders/getSaleOrdersDto";
import { GenericRequestDto } from "../models/generic-request.dto";

@Injectable({
  providedIn: "root",
})
export class OrderListingPaginatedService {
  private saleOrderManagementBaseURL =
    environment.baseUrl + "/SalesOrderManagement";
  private d365SynchroniserBaseURL = environment.baseUrl + "/D365Synchroniser";
  constructor(private _http: HttpClient) {}

  getAllSaleOrders(
    request: GenericRequestDto
  ): Observable<GenericResponseDto<GetSaleOrdersDto[]>> {
    return this._http.post<GenericResponseDto<GetSaleOrdersDto[]>>(
      //this.saleOrderManagementBaseURL + '/GetSaleOrderInformationPaginated',
      this.saleOrderManagementBaseURL + "/GetSaleOrderInformationPaginated",
      request
    );
  }

  getProjectInvoiceReportSales(
    request: GetProjectInvoiceReportSalesRequestDto
  ): Observable<GenericResponseDto<GetProjectInvoiceReportSalesResponseDto>> {
    return this._http.post<
      GenericResponseDto<GetProjectInvoiceReportSalesResponseDto>
    >(this.d365SynchroniserBaseURL + "/GetProjectInvoiceReportSales", request);
  }

  getProjectInvoiceReport(
    request: GetProjectInvoiceReportRequestDto
  ): Observable<GenericResponseDto<GetProjectInvoiceReportResponseDto>> {
    return this._http.post<
      GenericResponseDto<GetProjectInvoiceReportResponseDto>
    >(this.d365SynchroniserBaseURL + "/GetProjectInvoiceReport", request);
  }

  getSaleOrderInformationPaginatedExcel(
    request: GenericRequestDto
  ): Observable<Blob> {
    return this._http.post(
      this.saleOrderManagementBaseURL +
        `/GetSaleOrderInformationPaginatedExcel`,
      request,
      {
        responseType: "blob",
      }
    );
  }

  getProjectInvoiceProposalsBySalesOrderId(
    saleOrderId: string
  ): Observable<GenericResponseDto<GetInvoicesbySalesOrderIdResponseDto>> {
    return this._http.get<
      GenericResponseDto<GetInvoicesbySalesOrderIdResponseDto>
    >(
      this.d365SynchroniserBaseURL +
        "/GetProjectInvoiceProposalsBySalesOrderId?salesOrderId=" +
        saleOrderId
    );
  }
}
